import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToSnakeCase, transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

const post = ({ httpClient, venueId, classPayload }) =>
  httpClient
    .post(
      URLS.msSchedules.createClass(venueId),
      transformKeysToSnakeCase(classPayload),
      VENUE_FEATURE_PROBE_HTTP_CONFIG
    )
    .then(response => response.data)
    .then(transformKeysToCamelCase);

const put = ({ httpClient, venueId, classPayload: { id, ...restPayload } }) =>
  httpClient
    .put(
      URLS.msSchedules.updateClass(venueId, id),
      transformKeysToSnakeCase(restPayload),
      VENUE_FEATURE_PROBE_HTTP_CONFIG
    )
    .then(response => response.data)
    .then(transformKeysToCamelCase);

const handler = ({ httpClient }, venueId, classPayload) => {
  if (classPayload.id) {
    return put({ httpClient, venueId, classPayload });
  }

  return post({ httpClient, venueId, classPayload });
};

export default makeEntityScaffold('SAGA.API.CREATE_SCHEDULES_CLASS', handler, {
  defaultKey: (client, venueId, { id }) => id,
});
